




































import { Component, Emit, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import { ReserveType } from '@/types'

export interface ReservationCandidateListSearchConditionItem {
  reserveType: {
    input: ReserveType
  }
  key: {
    input: string
  }
}

export const defaultReservationCandidateListSearchConditionItem = (): ReservationCandidateListSearchConditionItem => ({
  reserveType: {
    input: ReserveType.Set
  },
  key: {
    input: ''
  }
})

@Component({
  components: {}
})
export default class ReservationCandidateListSearchCondition extends ComponentVue {
  @Ref()
  keyTextField!: AtomTextField

  @PropSync('input', {
    type: Object,
    required: true
  })
  searchCondition!: ReservationCandidateListSearchConditionItem

  get reserveType(): any {
    return ReserveType
  }

  focusKeyTextField(): void {
    this.keyTextField.atomTextField.focus()
  }

  blurKeyTextField(): void {
    this.keyTextField.atomTextField.blur()
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
